import { SalonAnalysis } from './salon-analysis'

/**
 * T-Mobile Salon Analysis - wrapper component using shared SalonAnalysis
 */
const TMobileSalonAnalysis = () => {
  return <SalonAnalysis operator="tmobile" />
}

export default TMobileSalonAnalysis
